/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DrugConstraint from './drug-constraint';
import DrugConstraintDetail from './drug-constraint-detail';
import DrugConstraintUpdate from './drug-constraint-update';
import DrugConstraintDeleteDialog from './drug-constraint-delete-dialog';

const DrugConstraintRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DrugConstraint />} />
    <Route path="new" element={<DrugConstraintUpdate />} />
    <Route path=":id">
      <Route index element={<DrugConstraintDetail />} />
      <Route path="edit" element={<DrugConstraintUpdate />} />
      <Route path="delete" element={<DrugConstraintDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DrugConstraintRoutes;
